import React from "react";
import * as CHQ from "chq";

import { ProfileLink, RecognitionLink } from "app/links";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type RecognitionApprovedNotificationProps = {
  notification: CHQ.NotificationRecognitionApproved;
  tabIndex?: number;
};

const RecognitionApprovedNotification: React.FC<RecognitionApprovedNotificationProps> = ({
  notification: { actor, entity }, tabIndex
}) => (
  <NotificationBody actor={actor}>
    <ProfileLink user={actor} tabIndex={tabIndex || 0} />
    {" "}
    <Trans>approved the recognition you gave:</Trans>
    {" "}
    <RecognitionLink recognition={entity} tabIndex={tabIndex || 0}>
      <Trans>view the recognition</Trans>
    </RecognitionLink>
  </NotificationBody>
);

export default RecognitionApprovedNotification;
